export const UserAccount = {
  Logout: 'Odhlásit se',
  PasswordChange: 'Změna hesla',
  UserAccount: 'Uživatelský účet',
};
